import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import Select from "react-select";
import clientService from '../../services/ClientService';
import userService from '../../services/UserService';
import "../../static/css/slide.css";

export default function SlideActionClient({show,onClose,onFetchClients,search,client}) {
    const { register, control, handleSubmit, reset, formState: { errors } } = useForm({
        defaultValues: {
            customer_type: "LEAD",
            status: "true",
        },
    });
    const [commercials, setCommercials] = useState({});
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };

    const normalizeData = (data) => {
        return Object.keys(data).reduce((acc, key) => {
            let value = data[key];

            if (typeof value === "string") {
                value = value.trim();
                if (key === "email") value = value.toLowerCase();
                else value = value.toUpperCase();
            }

            acc[key] = value;
            return acc;
        }, {});
    };

    const handleActionClient = async (data) => {
        const normalizedData = normalizeData(data);
        if(!data?.id_client) {
            clientService.add(normalizedData,reset)
                .then((res) => {
                    setMessage("Cliente aggiunto con successo!");
                    setErrorMsg("");
                    onFetchClients(search);
                    reset();
                }).catch((error) => {
                    console.error("Error add client: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiunta cliente. Riprova.");
                }
            );
        } else {
            clientService.update(normalizedData,reset)
                .then((res) => {
                    setMessage("Cliente modificato con successo!");
                    setErrorMsg("");
                    onFetchClients(search);
                }).catch((error) => {
                    console.error("Error update client: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiornamento cliente. Riprova.");
                }
            );
        }
    }

    const fetchUsers= async () => {
        try {
            const res = await userService.getAll();
            const resultsData = res.data || [];

            const commercial = resultsData.filter(user => user.role?.name === 'ROLE_COMM');

            setCommercials(commercial);

        } catch (error) {
            console.error('Error fetching users', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        reset(client);
    }, [client, reset]);

  	return (
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">{client.id_client ? "Modifica " : "Aggiungi "} Cliente</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionClient)}>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Denominazione*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.fullname ? "is-invalid" : ""}`}>
                                    <i className="bx bx-user" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.fullname ? "is-invalid" : ""}`}
                                    {...register('fullname', { required: 'Denominazione richiesta' })}
                                />
                            </div>
                            {errors.fullname && <div className="invalid-input">{errors.fullname.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">P.IVA</label>
                            <input className={`form-control ${errors.piva ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.piva ? errors.piva.message : ""}`}
                                {...register("piva")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Codice Fiscale</label>
                            <input className={`form-control ${errors.tax_code ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.tax_code ? errors.tax_code.message : ""}`}
                                {...register("tax_code")}
                             />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Indirizzo</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.address ? "is-invalid" : ""}`}>
                                    <i className="bx bx-map" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                    {...register("address",
                                        {
                                            maxLength: {
                                                value: 200,
                                                message: "Limite massimo 200"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.address && <div className="invalid-input">{errors.address.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Comune</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.comune ? "is-invalid" : ""}`}>
                                    <i className="bx bxs-city" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.comune ? "is-invalid" : ""}`}
                                    {...register("comune",
                                        {
                                            maxLength: {
                                                value: 200,
                                                message: "Limite massimo 200"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.comune && <div className="invalid-input">{errors.comune.message}</div>}
                        </div>
                        <div className="col-2 mb-6">
                            <label className="form-label">Provincia</label>
                            <input className={`form-control ${errors.provincia ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.provincia ? errors.provincia.message : ""}`}
                                {...register("provincia")}
                             />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mb-6">
                            <label className="form-label">Cap</label>
                            <input className={`form-control ${errors.cap ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.cap ? errors.cap.message : ""}`}
                                {...register("cap")}
                             />
                        </div>
                        <div className="col-3 mb-6">
                            <label className="form-label">Nazione</label>
                            <input className={`form-control ${errors.nazione ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.nazione ? errors.nazione.message : ""}`}
                                {...register("nazione")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Telefono</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.phone ? "is-invalid" : ""}`}>
                                    <i className="bx bx-phone" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                    {...register("phone",
                                        {
                                            maxLength: {
                                                value: 25,
                                                message: "Limite massimo 25"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.phone && <div className="invalid-input">{errors.phone.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Tipologia</label>
                            <select className={`form-select ${errors.customer_type ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.customer_type ? errors.customer_type.message : ""}`}
                                {...register('customer_type', { required: 'Seleziona la tipologia cliente' })}
                            >
                                <option value="LEAD">Lead</option>
                                <option value="ATTUALI">Attuali</option>
                                <option value="PERSO">Perso</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Pec</label>
                            <input className={`form-control ${errors.email_pec ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.email_pec ? errors.email_pec.message : ""}`}
                                {...register("email_pec")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">SDI</label>
                            <input className={`form-control ${errors.sdi ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.sdi ? errors.sdi.message : ""}`}
                                {...register("sdi")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Commerciale</label>
                            <Controller
                                name="user"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        isClearable
                                        placeholder="Seleziona un commerciale"
                                        className={`${errors.user ? "is-invalid" : ""}`}
                                        classNamePrefix='filter'
                                        options={commercials}
                                        getOptionLabel={(e) => `${e.name}`}
                                        getOptionValue={(e) => e.id_user}
                                        onChange={(selected) => field.onChange(selected)}
                                    />
                                )}
                            />
                            {errors.event && <div className="invalid-input">{errors.event.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Referente</label>
                            <input className={`form-control ${errors.referent ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.referent ? errors.referent.message : ""}`}
                                {...register("referent", {
                                    maxLength: {
                                        value: 255,
                                        message: "La lunghezza massima è di 512 caratteri!",
                                    }
                                })}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Email</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.email ? "is-invalid" : ""}`}>
                                    <i className="bx bx-envelope" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                    {...register("email", {
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Email non valida!"
                                        }
                                    })}
                                />
                            </div>
                            {errors.email && <div className="invalid-input">{errors.email.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Telefono Referente</label>
                            <input className={`form-control ${errors.smartphone ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.smartphone ? errors.smartphone.message : ""}`}
                                {...register("smartphone")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Stato</label>
                            <select className={`form-select ${errors.status ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.status ? errors.status.message : ""}`}
                                {...register('status', { required: 'Seleziona uno stato' })}
                            >
                                <option value="true">Attivo</option>
                                <option value="false">Non Attivo</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Metodo pagamento</label>
                            <select className={`form-select ${errors.payment_method ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.payment_method ? errors.payment_method.message : ""}`}
                                {...register('payment_method')}
                            >
                                <option value="">Seleziona</option>
                                <option value="BONIFICO">Bonifico</option>
                                <option value="RI.BANCARIA">Ri.Bancaria</option>
                            </select>
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Iban</label>
                            <input className={`form-control ${errors.iban ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.iban ? errors.iban.message : ""}`}
                                {...register("iban")}
                             />
                        </div>
                    </div>
                    <div className="col mb-6">
                        <label className="form-label">Note</label>
                        <textarea className="form-control" placeholder="Descrizione..."
                            {...register("note")}
                         />
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                    {!client.id_client && <button type="reset" className="btn btn-label-danger">Cancella</button>}
                </form>
            </div>
        </div>
	);
}